import addError from '../../../utils/error.jsx';

export function request( customerId, creditId, data ) {
    return {
        type: 'CUSTOMERS_REMOVE_FREEBET_CREDITS_REQUEST',
        customerId,
        creditId,
        data
    };
}

export function error( customerId, creditId, errors ) {
    addError( errors );

    return {
        type: 'CUSTOMERS_REMOVE_FREEBET_CREDITS_ERROR',
        customerId,
        creditId,
        errors
    };
}

export function finish( customerId, creditId ) {
    return {
        type: 'CUSTOMERS_REMOVE_FREEBET_CREDITS_FINISH',
        customerId,
        creditId
    };
}
